import MultiplierPercentagesTable from './MultiplierPercentagesTable';

export default MultiplierPercentagesTable;
